import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;

  ${(props) =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
`;

export const IconContainer = styled.div`
  margin: 16px 16px 0 0;

  & span {
    font-size: 2rem;
  }
`;

export const Content = styled.div``;

export const Label = styled.p`
  margin: 0 0 10px 0;
  font-size: 0.875rem;
`;

export const Value = styled.span`
  margin: 0;
  font-size: 1rem;
  font-weight: bold;

  &:not(:last-child) {
    margin-right: 10px;
  }
`;
